
window.onload = (event) => {
    initGTM();

    initCookiePopup();
}
